/**
 * Sample user list for the User Permissions page -- fallback only, used
 * when the real SSS `/users` fetch errors or returns nothing. `division`
 * is a best-guess field (same caveat as elsewhere in this app), used by
 * the Division filter.
 */

export const sampleUserPermissions = [
  { id: 'user-1', name: 'Phaneth Pho', email: 'phaneth.pho@kh.gt.com', role: 'admin', division: 'Audit', branchName: 'HQ' },
  { id: 'user-2', name: 'Sokha Chan', email: 'sokha.chan@kh.gt.com', role: 'staff', division: 'Audit', branchName: 'HQ' },
  { id: 'user-3', name: 'Dara Pich', email: 'dara.pich@kh.gt.com', role: 'staff', division: 'Audit', branchName: 'HQ' },
  { id: 'user-4', name: 'Vanna Sok', email: 'vanna.sok@kh.gt.com', role: 'manager', division: 'Advisory', branchName: 'Toul Kork' },
  { id: 'user-5', name: 'Ratana Kim', email: 'ratana.kim@kh.gt.com', role: 'staff', division: 'Tax', branchName: 'BKK1' },
  { id: 'user-6', name: 'Sopheak Ly', email: 'sopheak.ly@kh.gt.com', role: 'partner', division: 'Audit', branchName: 'HQ' },
  { id: 'user-7', name: 'Bopha Ouk', email: 'bopha.ouk@kh.gt.com', role: 'staff', division: 'Audit', branchName: 'Siem Reap' },
  { id: 'user-8', name: 'Mony Heng', email: 'mony.heng@kh.gt.com', role: 'staff', division: 'Advisory', branchName: 'HQ' },
  { id: 'user-9', name: 'Sreyneang Pov', email: 'sreyneang.pov@kh.gt.com', role: 'manager', division: 'Audit', branchName: 'Toul Kork' },
  { id: 'user-10', name: 'Kimheng Sar', email: 'kimheng.sar@kh.gt.com', role: 'staff', division: 'Tax', branchName: 'HQ' },
];
